module.exports = __webpack_public_path__ + "img/Intro-Profil.a7039f7e.png";